import { Button } from "@mui/material";
import { toast } from "@onair/minimal-ui/snackbar";
import { signIn } from "next-auth/react";

const ButtonSignIn = () => {
	const handleSignIn = async () => {
		await signIn("credentials", {
			email: "onair6@yopmail.com",
			password: "123456",
			redirect: false,
		})
			.then((response) => {
				console.log(response);
			})
			.catch((err) => {
				console.error(err);
				toast.error(
					(err as Error).message ?? "Mật khẩu hoặc tài khoản không đúng",
				);
			})
			.finally(() => {});
	};

	return (
		<Button
			variant="contained"
			color="primary"
			size="large"
			className=""
			onClick={handleSignIn}
		>
			Đăng nhập
		</Button>
	);
};
export default ButtonSignIn;
